var map = {
	"./day/logo.svg": 6112,
	"./day/marker.svg": 1628,
	"./day/marker_active.svg": 8555,
	"./day/position.svg": 6246,
	"./gps.svg": 4263,
	"./headphones.svg": 357,
	"./night/logo.svg": 929,
	"./night/marker.svg": 8225,
	"./night/marker_active.svg": 8214,
	"./night/position.svg": 4237,
	"./phone.svg": 7608,
	"./texture.svg": 6580,
	"./texture_blue.svg": 404
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6080;